export default "__VITE_ASSET__HDn07uAP__"